import Icon from '../components/Icon.vue'

Icon.register({"play-circle":{"width":1536,"height":1792,"paths":[{"d":"M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM1152 951q32-18 32-55t-32-55l-544-320q-31-19-64-1-32 19-32 56v640q0 37 32 56 16 8 32 8 17 0 32-9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/play-circle.js
// module id = 800
// module chunks = 0